import { OverlayApi } from "../api/overlay-api";

export const OverlayService = {
  createNewSession: async () => {
    try {
      const response = await OverlayApi.createNewSession({});
      return response.data.conversation;
    } catch (error) {
      console.error("Failed to create new session:", error);
      throw error;
    }
  },
  Feedback: async (rating, feedback_text) => {
    try {
      const response = await OverlayApi.submitFeedback(rating, feedback_text);
      console.log("the response for the rating", response);
      return response;
    } catch (error) {
      console.error("failed to sub,it the response", error);
      throw error;
    }
  },
  fetchAllConversations: async () => {
    try {
      const response = await OverlayApi.getAllConversations(); // calls API
      return response.conversation || []; // returns an array of conversations
    } catch (error) {
      console.error("Failed to fetch conversations:", error);
      throw error;
    }
  },
  updateConversation: async (conversation_id, actiontype, title) => {
    console.log("conversatio id1", conversation_id);
    console.log("action type passed1", actiontype);
    console.log("title value passed1", title);

    let payload = {};

    if (actiontype === "rename") {
      payload.title = title;
    } else if (actiontype === "archive") {
      payload.isarchived = true;
    }

    try {
      const response = await OverlayApi.updateConversation(
        conversation_id,
        payload
      );
      return response;
    } catch (error) {
      console.error("failed to update the conversation", error);
      throw error;
    }
  },

  updateJournal: async (payload, journal_id) => {
    console.log("journal id we are passing here", payload);
    try {
      const response = await OverlayApi.updateJournal(payload, journal_id);
      console.log("update the journal ", response);
      return response;
    } catch (error) {
      console.error("failed to update the journal", error);
      throw error;
    }
  },

  loadJournal: async (id) => {
    console.log("journal id we are passing here", id);
    try {
      const response = await OverlayApi.loadJournal(id);
      console.log("load the journal ", response);
      return response;
    } catch (error) {
      console.error("failed to edit the journal", error);
      throw error;
    }
  },

  deleteOneConversation: async (conversation_id) => {
    console.log("conversation id we are passing here", conversation_id);
    try {
      const response = await OverlayApi.deleteOne(conversation_id);
      console.log("deleting the one conversation ", response);
      return response;
    } catch (error) {
      console.error("failed to delete the conversation", error);
      throw error;
    }
  },

  fetchConversation: async (conversation_id) => {
    console.log("conversation id passed to fetchconversation", conversation_id);
    try {
      const response = await OverlayApi.fetchConversation(conversation_id);
      return response;
    } catch (error) {
      console.error("failed to fetch the conversation", conversation_id);
      throw error;
    }
  },

  getRetryMsg: async (msgId) => {
    try {
      console.log("Service layer: retrying message", msgId);
      const response = await OverlayApi.getRetryMsg(msgId);
      console.log("Service layer response", response);
      return response;
    } catch (error) {
      console.error("Failed to retry the message", error);
      throw error;
    }
  },

  getJournalEntries: async () => {
    try {
      console.log("service layer")
      const response = await OverlayApi.getJournalEntry();
      console.log("coming here service layer", response)
      return response;
    } catch (error) {
      console.error("Failed to save the journal entry", error);
    }
  },

  createJournalEntry: async (id, body, title) => {
    try {
      const response = await OverlayApi.createJournalEntry(id, body, title);
      return response;
    } catch (error) {
      console.error("Failed to save the journal entry", error);
    }
  },

  deleteJournalEntry: async (id) => {
    try {
      console.log("deleteJournalEntry", id)
      const response = await OverlayApi.deleteJournalEntry(id);
      return response;
    } catch (error) {
      console.error("Failed to delete this journal entry");
    }
  },

  createMood: async (moodData) => {
    return await OverlayApi.createMood(moodData);
  },

  getMood: async () => {
    return await OverlayApi.getMood();
  },

  fetchInsights: async () => {
    try {
      const response = await OverlayApi.fetchInsights();
      return response;
    } catch (error) {
      console.error("Failed to fetch insights");
    }
  },

  valiToken: async () => {
    try {
      const response = await OverlayApi.valiToken();
      return response;
    } catch (error) {
      console.error("Failed to fetch insights");
    }
  },

  
   latestConversation: async (patientid) => {
    try {
      const response = await OverlayApi.latestConversation(patientid);
      return response;
    } catch (error) {
      console.error("Failed to fetch latest conversation");
    }
  },

  saveFeedBack: async (feedback, id, tablename) => {
    try {
      const response = await OverlayApi.saveFeedBack(feedback, id, tablename);
      return response;
    } catch (error) {
      console.error("Failed to create chat feedback:", error);
      throw error;
    }
  },
};
